/* eslint-disable import/no-unresolved */
import * as Glyph from './glyphs';
import * as Identity from './identity';
import * as Indicator from './indicators';
import * as Nav from './nav';
import * as Service from './services';

enum CKIconVariant {
  'Glyphs' = 'Glyphs',
  'Nav' = 'Nav',
  'Services' = 'Services',
  'Identity' = 'Identity',
  'Indicators' = 'Indicators',
}

export { CKIconVariant };

export const CKIcons = {
  [CKIconVariant.Glyphs]: Glyph,
  [CKIconVariant.Nav]: Nav,
  [CKIconVariant.Services]: Service,
  [CKIconVariant.Identity]: Identity,
  [CKIconVariant.Indicators]: Indicator,
};

export * from './CKIconGradient';
